import T from 'T'

export const OTHER_SUSPENSION_REASON = 'OTHER'
export const PAYMENT_SUSPENSION_REASON = 'PAYMENT'
export const UNSUSPEND_SUSPENSION_REASON = 'UNSUSPEND'
export const LATE_PAYMENT_SUSPENSION_REASON = 'LATE_PAYMENT'
export const CREDIT_LIMIT_SUSPENSION_REASON = 'CREDIT_LIMIT'
export const LATE_PAYMENT_CREDIT_LIMIT_SUSPENSION_REASON = 'LATE_PAYMENT_CREDIT_LIMIT'
export const SUSPENSION_REASON_TYPES_OPTIONS = [
  { label: T.PAYMENT, value: PAYMENT_SUSPENSION_REASON },
  { label: T.OTHER, value: OTHER_SUSPENSION_REASON },
]

const SUSPENSION_TYPE_LABEL_MAP = {
  [PAYMENT_SUSPENSION_REASON]: T.PAST_DUE,
  [LATE_PAYMENT_SUSPENSION_REASON]: T.LATE_PAYMENT_SUSPENSION,
  [CREDIT_LIMIT_SUSPENSION_REASON]: T.CREDIT_LIMIT_SUSPENSION,
  [LATE_PAYMENT_CREDIT_LIMIT_SUSPENSION_REASON]: T.LATE_PAYMENT_AND_CREDIT_LIMIT,
  [OTHER_SUSPENSION_REASON]: T.OTHER,
}

export const getSuspensionReasonLabel = suspensionType => {
  return SUSPENSION_TYPE_LABEL_MAP[suspensionType] || suspensionType
}
